import React, { useState, useEffect } from "react";
import { Modal, Form, FormControl, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import { agent } from "../../utils/agent";
import * as API from "../../utils/apiPath";
import { showToasterWithOk } from "../../utils/helpers";

const SignUpModal = ({ show, onHide, defaultEmail = "" }) => {
  const { register, errors, handleSubmit, reset } = useForm({
    defaultValues: {
      email: defaultEmail || "",
    },
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (show) {
      reset({
        email: defaultEmail || "",
      });
    }
  }, [show, defaultEmail, reset]);

  const handleClose = () => {
    reset({
      email: "",
    });
    onHide();
  };

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      const sendRes = await agent.post(API.SENDACTIVATIONLINK, { email: data.email });
      setLoading(false);
      if (sendRes?.status === 200 || sendRes?.data?.status === 200 || sendRes?.data?.data === true) {
        showToasterWithOk(
          sendRes?.data?.message || "Activation link has been sent to your email address."
        );
        reset({ email: "" });
        onHide();
      } else {
        showToasterWithOk(
          sendRes?.data?.message || "Failed to send activation link."
        );
      }
    } catch (err) {
      setLoading(false);
      showToasterWithOk(
        err?.response?.data?.message || err?.message || "Failed to send activation link."
      );
    }
  };

  return (
    <Modal
      size="md"
      aria-labelledby="signup-modal-title"
      id="SignUpActivationModal"
      centered
      show={show}
      onHide={handleClose}
      className="custom-signup-modal"
    >
      <Modal.Header closeButton style={{ borderBottom: "1px solid #f0f0f0", padding: "1.25rem 1.5rem" }}>
        <Modal.Title id="signup-modal-title" style={{ fontSize: "1.35rem", fontWeight: "700", color: "#222" }}>
          Sign Up to vLookUp
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ padding: "1.5rem" }}>
        <p style={{ color: "#555", fontSize: "0.95rem", lineHeight: "1.5", marginBottom: "1.25rem" }}>
          Enter your email address for an activation link to complete registration.
        </p>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Form.Group controlId="signupEmailInput" style={{ marginBottom: "1.25rem" }}>
            <Form.Label style={{ fontSize: "0.9rem", fontWeight: "600", color: "#333", marginBottom: "0.4rem" }}>
              Email Address <span style={{ color: "#e83a48" }}>*</span>
            </Form.Label>
            <FormControl
              type="email"
              placeholder="Enter your email address"
              className={errors.email ? "form-control is-invalid" : "form-control"}
              style={{
                height: "3rem",
                fontSize: "1rem",
                borderRadius: "0.5rem",
                borderColor: errors.email ? "#dc3545" : "#ced4da",
                padding: "0.75rem 1rem",
              }}
              name="email"
              aria-invalid={errors.email ? "true" : "false"}
              ref={register({
                required: "Please enter your email address",
                pattern: {
                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                  message: "Invalid email address",
                },
                maxLength: {
                  value: 50,
                  message: "Your email should contain max 50 characters",
                },
              })}
            />
            <div className="d-flex justify-content-between align-items-start mt-2">
              <div className="d-flex align-items-center" style={{ gap: 12 }}>
                {errors.email && (
                  <label style={{ fontSize: "0.85rem", color: "#dc3545", margin: 0, display: "block" }}>
                    {errors.email.message}
                  </label>
                )}

              </div>
              <div className="ml-auto text-right d-flex align-items-center">
                <span
                  role="button"
                  tabIndex={0}
                  onClick={!loading ? handleSubmit(onSubmit) : undefined}
                  onKeyDown={(e) => {
                    if ((e.key === "Enter" || e.key === " ") && !loading) {
                      handleSubmit(onSubmit)();
                    }
                  }}
                  className="text-danger"
                  style={{
                    cursor: loading ? "not-allowed" : "pointer",
                    fontSize: "0.875rem",
                    fontWeight: "600",
                    textDecoration: "none",
                    opacity: loading ? 0.6 : 1,
                  }}
                >
                  Resend Link
                </span>
              </div>
            </div>
          </Form.Group>
          <Button
            type="submit"
            disabled={loading}
            style={{
              width: "100%",
              height: "3rem",
              backgroundColor: "#ff3e55",
              borderColor: "#ff3e55",
              color: "#fff",
              fontSize: "1.1rem",
              fontWeight: "600",
              borderRadius: "0.5rem",
              cursor: loading ? "not-allowed" : "pointer",
              transition: "all 0.2s ease-in-out",
            }}
          >
            {loading ? "Sending Link..." : "Submit"}
          </Button>
          <p className="signup-modal-login">
            Already have a Mentor / Mentee profile? To join as the other, create a new profile using a different email address. {" "}
            <Link to="/login" className="text-danger" onClick={handleClose}>
              Login
            </Link>
          </p>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default SignUpModal;
